// Quelle: /opt/lilasprojekte/frontend/src/main.tsx (Stand 2026-09-29)
// Geändert (SPEC 03 §3.1, §6.2): NEU_GELADEN = "hs.neu-geladen"; die Vorgaben des QueryClient
// (placeholderData: keepPreviousData, 4xx nie wiederholen) — der Client selbst wohnt in
// lib/abfrage.ts, damit der Anmeldespeicher ihn beim Abmelden leeren kann, ohne diese Datei
// (die beim Laden zeichnet) zu importieren; hier wird er wieder ausgeführt.
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./lib/abfrage";
// NUR diese zwei Stildateien, in dieser Reihenfolge, und nur hier:
// index.css bindet tokens.css VOR base.css ein (base.css benutzt die
// Variablen, die tokens.css setzt), app.css ergänzt danach die Schale.
import "./styles/index.css";
import "./styles/app.css";
import { App } from "./App";

export { queryClient };

// Nach einem Deploy tragen die Bausteine neue Namen, und ein Reiter, der die
// alte index.html noch offen hat, holt beim naechsten Bildschirmwechsel einen
// Baustein, den es nicht mehr gibt („Failed to fetch dynamically imported
// module"). Vite meldet das als `vite:preloadError`; die ehrliche Antwort ist
// EINMAL neu laden — der Merker verhindert eine Schleife, falls der Fehler
// eine andere Ursache hat (dann zeigt der Auffangkorb sie).
const NEU_GELADEN = "hs.neu-geladen";
window.addEventListener("vite:preloadError", (ereignis) => {
  let schon = false;
  try {
    schon = sessionStorage.getItem(NEU_GELADEN) === "1";
    if (!schon) sessionStorage.setItem(NEU_GELADEN, "1");
  } catch {
    /* ohne Speicher: einmal versuchen ist immer noch besser als nie */
  }
  if (schon) return;
  ereignis.preventDefault();
  window.location.reload();
});
try {
  // Der Merker gilt fuer EINEN Neuladeversuch; ist die Seite danach heil
  // hochgekommen, darf das naechste Deploy wieder einen ausloesen.
  window.setTimeout(() => sessionStorage.removeItem(NEU_GELADEN), 10_000);
} catch {
  /* siehe oben */
}

const wurzel = document.getElementById("root");
if (!wurzel) throw new Error("Kein #root im Dokument — index.html wurde verändert.");

// Der QueryClientProvider gehört HIERHER und nirgends sonst: ohne ihn wirft der ERSTE
// `useQuery` „No QueryClient set", und die Seite wäre eine weiße Fläche im Auffangkorb.
createRoot(wurzel).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
